// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    purchasing_find_suppliers: 'Buscando entre los proveedores',
    purchasing_supplier_profile: 'Leyendo la ficha del proveedor',
    purchasing_find_purchases: 'Buscando entre las compras',
    purchasing_purchase_detail: 'Leyendo el pedido',
    purchasing_summary: 'Sumando lo que hemos comprado',
    purchasing_draft_purchase: 'Abriendo un pedido en borrador',
    purchasing_find_requests: 'Mirando las solicitudes de compra',
    purchasing_request_purchase: 'Pidiendo que se compre algo',
    purchasing_approve_request: 'Aprobando una solicitud de compra',
    purchasing_reject_request: 'Rechazando una solicitud de compra',
  },
  ca: {
    purchasing_find_suppliers: 'Cercant entre els proveïdors',
    purchasing_supplier_profile: 'Llegint la fitxa del proveïdor',
    purchasing_find_purchases: 'Cercant entre les compres',
    purchasing_purchase_detail: 'Llegint la comanda',
    purchasing_summary: 'Sumant el que hem comprat',
    purchasing_draft_purchase: 'Obrint una comanda en esborrany',
    purchasing_find_requests: 'Mirant les sol·licituds de compra',
    purchasing_request_purchase: 'Demanant que es compri alguna cosa',
    purchasing_approve_request: 'Aprovant una sol·licitud de compra',
    purchasing_reject_request: 'Rebutjant una sol·licitud de compra',
  },
  en: {
    purchasing_find_suppliers: 'Looking through the supplier file',
    purchasing_supplier_profile: 'Reading the supplier\'s file',
    purchasing_find_purchases: 'Looking through the purchases',
    purchasing_purchase_detail: 'Reading the order',
    purchasing_summary: 'Adding up what we have bought',
    purchasing_draft_purchase: 'Opening a draft order',
    purchasing_find_requests: 'Looking at the purchase requests',
    purchasing_request_purchase: 'Asking for something to be bought',
    purchasing_approve_request: 'Approving a purchase request',
    purchasing_reject_request: 'Turning a purchase request down',
  },
  fr: {
    purchasing_find_suppliers: 'Recherche parmi les fournisseurs',
    purchasing_supplier_profile: 'Lecture de la fiche du fournisseur',
    purchasing_find_purchases: 'Recherche parmi les achats',
    purchasing_purchase_detail: 'Lecture de la commande',
    purchasing_summary: 'Bilan de nos achats',
    purchasing_draft_purchase: 'Ouverture d’une commande en brouillon',
    purchasing_find_requests: 'Consultation des demandes d’achat',
    purchasing_request_purchase: 'Demande d’achat',
    purchasing_approve_request: 'Approbation d’une demande d’achat',
    purchasing_reject_request: 'Refus d’une demande d’achat',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
